import { prefix } from './actions';
import { IRootState } from '../reducer';

export const loading = (state: IRootState) => state[prefix].loading;

export const error = (state: IRootState) => state[prefix].error;

export const successfullyRegistered = (state: IRootState) =>
         state[prefix].successfullyRegistered;
